export const environment = {
	baseAccountsUrl: 'http://api.accounts.amlreputacional.amldev.com.br',
	baseEfetividadeUrl: 'http://api.avaliacao-efetividade.amldev.com.br',
	production: false,
};
